import "./PdtList.css";

import { Link } from "react-router-dom";
import { getRootUrl, getUploadFileUrl } from "../../consts";
import { useEffect, useState } from "react";

const rootUrl = getRootUrl();
export default function PdtList(props){
    const [pdts, setPdts] = useState();
    const [pdtsCnt, setPdtsCnt] = useState(0);
    useEffect(_=>{
        setPdts(props.pdts);
        setPdtsCnt(props.pdtsCnt);
    }, [props.pdts]);

    return  <div>
          {/* <p>{searchFor?`search for " ${searchFor} "`:''}</p> */}
          {/* {
              (pdts===undefined)?<strong className="py-3">loading ...</strong>
              :(pdts.length<1)?<strong className="py-3">no product found in this category.</strong>:
              <strong className="my-3">{pdtsCnt} products found in this category.</strong>
          } */}
        
        <div>
            <div className="row">
            {(pdts||[]).map((pdt,pdtIdx)=>{
                let pdtImgs = [];
                try{
                    pdtImgs = JSON.parse(pdt.images || "[]");
                }catch(err){
                    pdtImgs = [];
                }

                return <div key={pdtIdx} className="col">
                    <div className="card box-shadow m-1">
                        <div  className="card-img-top" style={{"height":"10em",  "backgroundPosition": "center top", "backgroundSize":"cover",
                            "backgroundImage":`url(${(pdtImgs.length>0)&&getUploadFileUrl(pdtImgs[0].url)})`
                        }} ></div>
                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                            <div className="card-body">
                                <h5 className="card-title">{pdt.name}</h5>
                                <span>sn: {pdt.sn}</span>
                                <p>price: $ 100.00 </p>
                                <Link 
                                    className="btn btn-sm btn-primary me-1"
                                    to={`${rootUrl}/app2/pdtDetail/${pdt.category}/${pdt.__id}`}
                                >detail</Link>
                                <a href={"#"} className="btn btn-sm btn-primary">add to cart</a>
                            </div>
                    </div>
                </div>;
            })}
            </div>
        </div>
    </div>
}